import React from 'react';

const Contact = ({ text, disabled, onClick }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`btn btn-lg ${
        disabled ? 'btn-danger' : 'btn-success'
      } btn-block`}
    >
      <i className="fa fa-phone" />
      {text}
    </button>
  );
};

export default Contact;
